import { useTranslation } from "react-i18next";

import Cell from "../../components/common/AccordionTable/components/Cell";
import DropdownItem from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DropdownItem";

export const useHeaderViewerAdapter = () => {
  const { t } = useTranslation();

  const headerData = [t("global.name"), t("global.result")];

  const renderRowContent = item => {
    return (
      <>
        <Cell>{item.name}</Cell>
        <Cell>{item.result}</Cell>
      </>
    );
  };

  const renderHeaderTitle = item => item.name;

  const renderDropdownContent = item => {
    return (
      <>
        <DropdownItem>
          <span>{headerData[1]} </span>
          {item.result}
        </DropdownItem>
      </>
    );
  };

  return {
    headerData,
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
  };
};
